import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import EmployeesTable from '../../components/employees/EmployeesTable';

const EmployeesArchive = () => (<WrapperSection><GlobalBreadcrumbs /><EmployeesTable isArchive /></WrapperSection>);
export default EmployeesArchive;
